export default {

    watch: {
        value() {
            this.resetValidation();
        }
    },

    methods: {
        resetValidation(){
            this.$refs.form.resetValidation();
        },

        validate() {
            return this.$refs.form.validate();
        },
        isValid() {
            return this.$refs.form.validate();
        }
    },

}